<template>
    <div>
        <p class="h5 mt-5 text-left">Listing</p>
        <ul class="nav flex-column text-left">
            <li><a class="btn text-left pl-0" :href="circlepixUrl('listingEdit', `tourid=${listing.id}`)"> Edit Listing Info</a></li>
            <li><a class="btn text-left pl-0" :href="circlepixUrl('listingStatus', `tourid=${listing.id}`)"> Add Banner</a></li>
            <li><a class="btn text-left pl-0" :href="circlepixUrl('preferencesTour', `tourid=${listing.id}`)"> Tour Preferences</a></li>
            <li><a class="btn text-left pl-0" :href="circlepixUrl('listingStatsNew', `tourid=${listing.id}`)"> Tour Stats</a></li>
            <li><a class="btn text-left pl-0" :href="circlepixUrl('automateHome', `tourid=${listing.id}`)"> Marketing Automation</a></li>
            <li v-show="this.isTokenUserAnyAdmin"><a class="btn text-left pl-0" :href="circlepixUrl('listingTransfer', `tourid=${listing.id}`)">Transfer Listing</a></li>
        </ul>

      <p class="h5 mt-4 text-left">Media</p>
        <ul class="nav flex-column text-left">
            <li v-for="link in mediaLinks" :key="link.label">
                <a class="btn text-left pl-0" :href="circlepixUrl(link.href)">{{link.label}}</a>
            </li>
        </ul>
    </div>
</template>

<script>
  import {cpixdomain} from "../../config";
  import {mapGetters} from 'vuex';

  export default {
        name: "ListingLeftNav",
        props: ['listing'],

        data() {
            return {

                mediaLinks: [
                    {label: 'Change Audio', href: 'listingAudio'},
                    {label: 'Download Stills', href: 'listingHiRes'},
                    {label: 'Edit Media', href: 'tourImageInfo'},
                    {label: 'Arrange Media', href: 'tourImageOrder'},
                    {label: 'Activate Media', href: 'listingActivateImages'},
                    {label: 'Add Media', href: 'ssUpload'},
                    {label: 'Create/Edit Floor Plan', href: 'editFloorplan'},
                ]
            }
        },
        computed: {
          ...mapGetters([
            'me',
            'isTokenUserAnyAdmin'
          ]),
        },
        methods: {
            circlepixUrl(string, params){
                if(!string){
                    return '#';
                }

                if(params){
                  return `${cpixdomain}/aspen/${string}.htm?${params}`
                } else {
                  return `${cpixdomain}/aspen/${string}.htm`
                }
            }
        }
    }
</script>

<style scoped lang="scss">
  @import "../../assets/scss/variables";
    table {
        .menu {
            width: 100%;
            position: absolute;
            top: 240px;
            text-align: left;
            margin-left: 20px;
        }
    }


    ul {
        list-style: none;
        color: #444444;
    }

    a {
        color: #444444;

        &:hover{
            color: #92C83E;
        }
    }

</style>
